import Auth0ProviderWithHistory from './withAuth0History';

export default Auth0ProviderWithHistory;
